import React from "react"
import { ConsumerAppointmentsPage } from "#/pages/consumer/appointments/page"
import { PageNotFound } from "#/components/views/error/PageNotFound"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

export function AppointmentsRoute(): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  if (isLoading || isError || !programFlags) return <PageLoading />
  return programFlags.isConsumer ? <ConsumerAppointmentsPage /> : <PageNotFound />
}
